import React, { useEffect } from "react";
import { Button, Form, Space, Input, InputNumber, Select } from "antd";
import { DollarOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { ProductInterface } from "src/store/mine_craft/productsSlice";


const CURRENCY_OPTIONS = [
  { value: 'coins',   label: 'coins' },
  { value: 'c_coins', label: 'c_coins' },
];

type dataType = {
  products: ProductInterface[];
  bundle_id: number;
}

interface propsInterface {
  onFinish: Function;
  data: dataType;
}

const _ListForm = ({ onFinish, data }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [data, form]);

  const ProductField = ({ name, remove, restField }: any) => (
    <Space style={{ display: 'flex', marginBottom: 2 }}>
      <Form.Item
        {...restField}
        name={[name, 'productid']}
        rules={[{ required: true, message: 'Missing productid' }]}
      >
        <Input placeholder="com.example.100" />
      </Form.Item>

      <Form.Item
        {...restField}
        name={[name, 'amount']}
        rules={[{ required: true, message: 'Missing amount' }]}
      >
        <InputNumber
          min={0}
          step={50}
          placeholder="100"
        />
      </Form.Item>

      <Form.Item
        {...restField}
        name={[name, 'price']}
      >
        <InputNumber
          min={0}
          step={1}
          placeholder="4.99"
          prefix={<DollarOutlined />}
        />
      </Form.Item>

      <Form.Item
        {...restField}
        name={[name, 'currency']}
      >
        <Select options={CURRENCY_OPTIONS} style={{ width: 110 }} />
      </Form.Item>

      <MinusCircleOutlined onClick={() => remove(name)} className='v-mb-20' />
    </Space>
  );

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      className='v-form'
      autoComplete="off"
      initialValues={data}
    >
      <Form.List name="products">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
                <ProductField
                  key={key}
                  name={name}
                  remove={remove}
                  restField={restField}
                />
              )
            )}

            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add({ currency: 'coins' })}
                block
                icon={<PlusOutlined />}
              >
                Add product
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Apply
        </Button>
      </Form.Item>
    </Form>
  );
}

export default _ListForm;
